import script from "./Filters.vue?vue&type=script&setup=true&lang=js"
export * from "./Filters.vue?vue&type=script&setup=true&lang=js"

import "./Filters.vue?vue&type=style&index=0&id=616b1648&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-616b1648"]])

export default __exports__